import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import BaseMixer from "../../BaseMixer";
import { IDetailedNotificationDTO } from "@/store/models/notification/DetailedNotification";
import { NotificationsModule } from "@/store/modules/notification.module";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let MemberAdditionComponent = /** @class */ (() => {
    var _a;
    let MemberAdditionComponent = class MemberAdditionComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.tenantId = localStorage.getItem("tenantId");
        }
        UpdateIsActive(notification) {
            if (!notification.isComplete) {
                return;
            }
            NotificationsModule.UpdateIsActive(notification.id);
            this.$router.push({ name: "ProjectOverview", params: { projectId: this.notificationDetails.projectId } });
        }
        UpdateIsSeen() {
            NotificationsModule.UpdateIsSeen(this.notification.id);
        }
        get notificationDetails() {
            return this.notification.notificationData;
        }
        created() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDetailedNotificationDTO !== "undefined" && IDetailedNotificationDTO) === "function" ? _a : Object)
    ], MemberAdditionComponent.prototype, "notification", void 0);
    MemberAdditionComponent = __decorate([
        Component({
            name: "MemberAdditionComponent",
            components: {},
        })
    ], MemberAdditionComponent);
    return MemberAdditionComponent;
})();
export default MemberAdditionComponent;
